








import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import gsap from 'gsap';
import { Draggable, InertiaPlugin } from 'gsap/all';

@Component({
	components:{}
})
export default class DiscsTest extends Vue {

	public mounted():void {
		let discs = <HTMLImageElement[]>this.$refs.disc;
		for (let i = 0; i < discs.length; i++) {
			gsap.set(discs[i], {rotation:Math.round(Math.random()*4)*90})
			Draggable.create(discs[i], {type:"rotation", resistance: 0.75, inertia:true, snap:(endValue) => {
				return Math.round(endValue / 90) * 90;
			}});
		}
	}

	public beforeDestroy():void {
		
	}

}
